/* eslint-disable max-len */
const formatToSelectOption = (value, text) => ({
  label: text,
  value,
});

const addDefaultOption = (options, defaultLabel = 'Selecionar...') => [{ value: 0, label: defaultLabel }, ...options];

export const formatData = ({
  equipmentGroup,
  equipment,
  operatorGroup,
  operator,
  material,
  turns,
  teams,
  elements,
  subElements,
  filters,
  values,
  translate,
}) => {
  const ESCAVATOR_ID = 1;
  const LOADER_ID = 15;
  const ROCK_FILL_ID = 29;

  const ACTIVE_STATUS = 1;

  const equipmentsGroups = equipmentGroup
    .filter(
      item => item?.id_equipament === filters.equipmentType
          && item?.active === ACTIVE_STATUS,
    )
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const equipments = equipment
    .filter(
      item => item?.id_group === values.id_group && item?.active === ACTIVE_STATUS,
    )
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const loadEquipments = equipment
    .filter(
      item => [ESCAVATOR_ID, LOADER_ID, ROCK_FILL_ID].includes(item.id_equip)
          && item?.active === ACTIVE_STATUS,
    )
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const originElement = elements
    .filter(item => item?.active === ACTIVE_STATUS)
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const originPointElement = subElements
    .filter(
      item => item?.id_element === values.id_mine && item?.active === ACTIVE_STATUS,
    )
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const destinationElement = elements
    .filter(item => item?.active === ACTIVE_STATUS)
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const destinationPointElement = subElements
    .filter(
      item => item?.id_element === values.id_destination
          && item?.active === ACTIVE_STATUS,
    )
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const operatorGroups = operatorGroup
    .filter(item => item?.active === ACTIVE_STATUS)
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const operators = operator
    .filter(
      item => item?.id_group === values?.id_operator_truck_group
          && item?.active === ACTIVE_STATUS,
    )
    .map(item => formatToSelectOption(item?.id_operator, item?.name)) || [];

  const materials = material
    .filter(item => item?.active === ACTIVE_STATUS)
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const turn = turns
    .filter(item => item?.active === ACTIVE_STATUS)
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const team = teams
    .filter(item => item?.active === ACTIVE_STATUS)
    .map(item => formatToSelectOption(item?.id, item?.name)) || [];

  const defaultLabel = translate('common:Select');

  return {
    equipmentsGroups: addDefaultOption(
      equipmentsGroups,
      defaultLabel,
    ),
    equipments: addDefaultOption(equipments, defaultLabel),
    loadEquipments: addDefaultOption(loadEquipments, defaultLabel),
    originElement: addDefaultOption(originElement, defaultLabel),
    originPointElement: addDefaultOption(
      originPointElement,
      defaultLabel,
    ),
    destinationElement: addDefaultOption(destinationElement, defaultLabel),
    destinationPointElement: addDefaultOption(
      destinationPointElement,
      defaultLabel,
    ),
    operatorGroups: addDefaultOption(operatorGroups, defaultLabel),
    operators: addDefaultOption(operators, defaultLabel),
    materials: addDefaultOption(materials, defaultLabel),
    turn: addDefaultOption(turn, defaultLabel),
    team: addDefaultOption(team, defaultLabel),
  };
};

const isFieldFilled = (field, value, allowZeroFields) => {
  if (allowZeroFields.includes(field)) {
    return value !== undefined && value !== null && value !== '';
  }
  return value !== undefined && value !== null && value !== 0;
};

export const isFormValid = ({ values, fieldDependecies, allowZeroFields }) => {
  const isAnyFieldFilled = Object.entries(values).some(([field, value]) => isFieldFilled(field, value, allowZeroFields));

  if (!isAnyFieldFilled) return false;

  const allDependenciesAreValid = Object.entries(fieldDependecies)
    .every(([mainField, dependentField]) => {
      const isMainFieldFilled = isFieldFilled(
        mainField,
        values[mainField],
        allowZeroFields,
      );

      if (!isMainFieldFilled) return true;

      return isFieldFilled(
        dependentField,
        values[dependentField],
        allowZeroFields,
      );
    });
  return allDependenciesAreValid;
};

export const getFieldError = ({
  fieldDependecies,
  fieldKey,
  values,
  allowZeroFields,
}) => {
  const mainFieldName = Object.entries(fieldDependecies)
    .find(([_, dependent]) => dependent === fieldKey)?.[0];

  if (!mainFieldName) return false;

  const mainFilled = isFieldFilled(
    mainFieldName,
    values[mainFieldName],
    allowZeroFields,
  );
  const dependentFilled = isFieldFilled(
    fieldKey,
    values[fieldKey],
    allowZeroFields,
  );

  return mainFilled && !dependentFilled;
};

export const getSlicedData = (startIndex, endIndex, list) => list?.slice(startIndex, endIndex) || [];

export const optionsToSelectBatch = ({ pagination, list }) => {
  if (!pagination || !Array.isArray(pagination.batchPages) || !list) return [];

  const { batchSize = 1500, batchPages = [] } = pagination;

  const options = batchPages.map((pageIndex) => {
    const startCount = pageIndex * batchSize + 1;
    const endCount = Math.min((pageIndex + 1) * batchSize, list.length);

    const option = `${startCount}-${endCount}`;
    return formatToSelectOption(option, option);
  });

  return options;
};
